<section class="row astrology" aria-labelledby="astrology">
    <div class="col-sm-12 col-md-5" *ngIf="exploreAstro == 'required'">
        <h2 id="astrology" class="h2 txt-warning mb-4">Astrology</h2>
        <p>In arcu at pulvinar arcu pellentesque duis consequat ornare. Tincidunt eget et pretium ullamcorper donec
            adipiscing lobortis. A mi dis non nullam.</p>
        <button type="button" class="btn btn-primary orange-stroked text-uppercase" (click)="gotoAstrologer()">explore</button>
    </div>

    <div class="col-12 d-flex mt-5 p-0">
        <div class="col-4 predict-card">
            <button class="btn position-relative p-0 overflow-hidden"  (click)="gotoAstrologer()">
                <span class="info position-absolute text-left">
                    <h3 class="h3 mb-2">CONSULTATIONS</h3>
                    <p class="mb-0">on call, chat & video</p>
                </span>

                <img src="https://images.pexels.com/photos/1275413/pexels-photo-1275413.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
                    alt="..." class="img-fluid">
            </button>
        </div>

        <div class="col-4 predict-card">
            <button class="btn position-relative p-0 overflow-hidden">
                <span class="info position-absolute text-left">
                    <h3 class="h3 mb-2">LIFE PREDICTIONS</h3>
                    <p class="mb-0">from experts chosen by you</p>
                </span>

                <img src="https://media.istockphoto.com/photos/zodiac-signs-picture-id136899902?s=2048x2048"
                    alt="..." class="img-fluid">
            </button>
        </div>

        <div class="col-4 predict-card">
            <button class="btn position-relative p-0 overflow-hidden">
                <span class="info position-absolute text-left">
                    <h3 class="h3 mb-2">LIVE AVAILABILITY</h3>
                    <p class="mb-0">our astrolgers are online</p>
                </span>

                <img src="https://images.pexels.com/photos/6806735/pexels-photo-6806735.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
                    alt="..." class="img-fluid">
            </button>
        </div>
    </div>
</section>